import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getQuestions = () => axios.get(`${API}/questions`).then((r) => r.data);
export const startAssessment = (payload) => axios.post(`${API}/assessments`, payload).then((r) => r.data);
export const submitAssessment = (id, answers) => axios.post(`${API}/assessments/${id}/submit`, { answers }).then((r) => r.data);
export const getReport = (id) => axios.get(`${API}/assessments/${id}/report`).then((r) => r.data);
export const getComparison = (id) => axios.get(`${API}/assessments/${id}/comparison`).then((r) => r.data);
export const emailReport = (id, email) => axios.post(`${API}/assessments/${id}/email-report`, { email }).then((r) => r.data);
export const registerInterest = (payload) => axios.post(`${API}/interest`, payload).then((r) => r.data);
export const requestProspectus = (payload) => axios.post(`${API}/prospectus`, payload).then((r) => r.data);
export const pdfUrl = (id) => `${API}/assessments/${id}/report.pdf`;
export const createCheckout = (payload) => axios.post(`${API}/payments/checkout`, payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) => axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);

export const adminLogin = (email, password) => axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);
const authHeaders = (token) => ({ headers: { Authorization: `Bearer ${token}` } });
export const adminOverview = (token) => axios.get(`${API}/admin/overview`, authHeaders(token)).then((r) => r.data);
export const adminLeads = (token) => axios.get(`${API}/admin/leads`, authHeaders(token)).then((r) => r.data);
export const markInterestBooked = (id, booked, token) => axios.post(`${API}/admin/interests/${id}/booked`, { booked }, authHeaders(token)).then((r) => r.data);
export const updateClarityOutcome = (id, outcome, token) => axios.patch(`${API}/admin/interests/${id}/clarity-outcome`, { outcome }, authHeaders(token)).then((r) => r.data);
export const adminPayments = (token) => axios.get(`${API}/admin/payments`, authHeaders(token)).then((r) => r.data);
export const adminUsers = (token) => axios.get(`${API}/admin/users`, authHeaders(token)).then((r) => r.data);
export const createAdminUser = (email, token) => axios.post(`${API}/admin/users`, { email }, authHeaders(token)).then((r) => r.data);
export const resetAdminPassword = (id, token) => axios.post(`${API}/admin/users/${id}/reset-password`, {}, authHeaders(token)).then((r) => r.data);
export const refundPayment = (sessionId, token) => axios.post(`${API}/admin/payments/${sessionId}/refund`, {}, authHeaders(token)).then((r) => r.data);
export const downloadCsv = async (path, filename, token) => {
  const r = await axios.get(`${API}/admin/export/${path}`, { ...authHeaders(token), responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
